export const CalendarIcon = props => (
  <svg
    width="24"
    height="24"
    viewBox="-1 -1 22 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 3V1M13 3V5M13 3H8.5M1 9V18C1 19.1046 1.89543 20 3 20H17C18.1046 20 19 19.1046 19 18V9H1Z"
      stroke={props.stroke ? props.stroke : '#444444'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 9V5C1 3.89543 1.89543 3 3 3H5"
      stroke={props.stroke ? props.stroke : '#444444'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 1V5"
      stroke={props.stroke ? props.stroke : '#444444'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 9V5C19 3.89543 18.1046 3 17 3H16.5"
      stroke={props.stroke ? props.stroke : '#444444'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
